import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useToggle } from 'react-use';

import SignatureProgressInformationContent from '@app/components/Modal/SignatureProgressInformation/SignatureProgressInformationContent';
import SignatureProgressInformationFooter from '@app/components/Modal/SignatureProgressInformation/SignatureProgressInformationFooter';
import SignatureProgressInformationHeader from '@app/components/Modal/SignatureProgressInformation/SignatureProgressInformationHeader';
import Status from '@app/store/document/Status';
import { fetchSigningProgressInformation } from '@app/store/signingProgressInformation/actions';
import { getDocument } from '@app/store/signingProgressInformation/selectors';

import { SigningProgressDocumentAttachmentListModal } from '../DocumentAttachmentListModal/SigningProgressDocumentAttachmentListModal';

interface SignatureProgressInformationModalProps {
  documentId: string;
}

function SignatureProgressInformationModal({ documentId }: SignatureProgressInformationModalProps) {
  const dispatch = useDispatch();

  const document = useSelector(getDocument);

  const [isAttachmentModalOpen, toggleAttachmentModalOpen] = useToggle(false);

  useEffect(() => {
    if (documentId) {
      dispatch(fetchSigningProgressInformation({ documentId }));
    }
  }, [dispatch, documentId]);

  return (
    <div className="Container Container--max-xl">
      <div className="Card Card--pop WindowModal WindowModal--fixed-height">
        <SignatureProgressInformationHeader />
        <SignatureProgressInformationContent />
        {document && document.status === Status.COMPLETED && (
          <SignatureProgressInformationFooter
            documentId={documentId}
            onOpenAttachmentsModal={toggleAttachmentModalOpen}
          />
        )}
      </div>
      {isAttachmentModalOpen && (
        <SigningProgressDocumentAttachmentListModal
          documentId={documentId}
          isDocumentCompleted={document.status === Status.COMPLETED}
          onClose={toggleAttachmentModalOpen}
        />
      )}
    </div>
  );
}

export default SignatureProgressInformationModal;
